import InputField from 'components/fields/InputField';
import { useRef, useState } from 'react';

const EditAssignment = ({ assignment, onClose, onSave }) => {
  const [form, setForm] = useState({ ...assignment });
  const [newPdfFile, setNewPdfFile] = useState(null);
  const [fileName, setFileName] = useState(assignment.pdfFileName || '');
  const fileInputRef = useRef(null);

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      const file = e.target.files[0];
      setNewPdfFile(file);
      setFileName(file.name);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (newPdfFile) {
      const updatedFormWithFile = {
        ...form,
        newPdfFile: newPdfFile,
      };
      onSave(updatedFormWithFile);
    } else {
      onSave(form);
    }
  };

  const handleViewPdf = () => {
    if (form.pdfFilePath) {
      const pdfUrl = `${BASE_URL}/${form.pdfFilePath.replace(/\\/g, '/')}`;
      window.open(pdfUrl, '_blank');
    }
  };

  return (
    <div className="bg-black fixed inset-0 z-50 flex items-center justify-center bg-opacity-50">
      <div className="relative w-full max-w-md rounded bg-white p-4 shadow-md dark:bg-navy-700 dark:text-white">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-2 top-2 h-10 w-8 rounded-full text-3xl text-brand-900 transition duration-200 dark:text-brand-900 dark:text-navy-200"
        >
          &times;
        </button>
        <h3 className="mb-4 text-xl font-bold">Edit Assignment</h3>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <InputField
              label="Title"
              name="title"
              value={form.title}
              onChange={handleChange}
              className="w-full rounded border p-2"
            />
          </div>
          <div className="mb-4">
            <InputField
              label="Question"
              name="question"
              value={form.question || ''}
              onChange={handleChange}
              className="w-full rounded border p-2"
            />
          </div>
          <div className="mb-4">
            <InputField
              label="Due Date"
              name="dueDate"
              value={form.dueDate ? form.dueDate.split('T')[0] : ''}
              onChange={handleChange}
              type="date"
              className="w-full rounded border p-2"
            />
          </div>

          <div className="mb-4">
            <label className="mb-2 block font-bold">PDF File</label>
            {form.pdfFileName && !newPdfFile && (
              <div className="mb-2 flex items-center gap-2">
                <span className="text-sm">{form.pdfFileName}</span>
                <button
                  type="button"
                  onClick={handleViewPdf}
                  className="rounded bg-blue-500 px-2 py-1 text-xs text-white"
                >
                  View
                </button>
              </div>
            )}

            <div className="flex items-center gap-2">
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                accept=".pdf"
                className="hidden"
              />
              <button
                type="button"
                onClick={() => fileInputRef.current.click()}
                className="rounded bg-gray-200 px-3 py-1 text-sm text-gray-700 hover:bg-gray-300 dark:bg-gray-600 dark:text-white dark:hover:bg-gray-500"
              >
                {form.pdfFileName ? 'Change PDF' : 'Upload PDF'}
              </button>
              {newPdfFile && (
                <span className="text-sm text-green-600 dark:text-green-400">
                  New file: {newPdfFile.name}
                </span>
              )}
            </div>
          </div>

          <div className="flex justify-end gap-2">
            <button
              type="submit"
              className="rounded bg-green-500 px-4 py-2 text-white"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAssignment;
